<template>
  <div>
    <dialogs
      :mshow="mshow"
      :scroll="false"
      :mask="false">
        <div class="beast-loading__icon" :class="{'icon_white': white}"></div>
    </dialogs>
  </div>
</template>

<script>
import dialogs from '@/components/dialog/index.vue'
export default {
  name: 'loading',
  components: {
    dialogs
  },
  props: ['white'],
  data(){
    return {
      mopacity : 0,
      mshow : false
    }
  }
}
</script>

<style lang="stylus">
  @import '../../common/styl/global'

  // .beast-loading
  //   position fixed
  //   width 100%
  //   height 100%
  //   top 0
  //   left 0
  //   z-index 1001
  // .beast-loading__icon__warp
  //   position absolute
  //   top 50%
  //   left 50%
  //   transform translate(-50%, -50%)
  //   z-index 1001

  .beast-loading__icon
    width rem(30)
    height rem(30)
    // background url('./assets/loading.png') no-repeat
    background url('//img.thebeastshop.com/app/loading.gif') no-repeat
    background-size cover
    // animation zz 1.5s cubic-bezier(.19,.45,.66,.41) infinite
    &.icon_white
      background url('./assets/loading-white.png') no-repeat
      background-size cover
  @keyframes zz {
    from {
      transform rotate(0deg)
    }
    to {
      transform rotate(360deg)
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?017aa92a